/* eslint-disable @nx/enforce-module-boundaries */
import { Button, Heading, Spinner, Stack, Text, Collapse, } from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { SearchContext } from '../context';
import { Divider, HStack } from '@mybridge/ui';
import { SearchTeamsFilters } from './filters';
import { SearchTeamsListing } from './listing';
import { useDisclosure } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import { IconButton } from '@chakra-ui/react';
import { Filters } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const SearchTeams = forwardRef(({ count, listing, ...props }, ref) => {
  const {
    teamsFetchNextPage,
    teamsSearchIsFetching,
    teamsSearchIsLoading,
    teamsHasNextPage,
    teamsTotalCount,
    query,
  } = useContext(SearchContext);
  const filterDisc = useDisclosure();
  const { t } = useTranslator();
  return (
    <Stack>
      {isMobile ? (
        <Collapse style={{overflow:"inherit"}} in={filterDisc?.isOpen} animateOpacity>
          <SearchTeamsFilters />
          <Divider my={2} />
        </Collapse>
      ) : (
        ''
      )}
      <Stack spacing={0}>
        <HStack w="100%"
            justifyContent="space-between"
            alignItems="center"
            gap={0}>
          <Heading as="h1" pl={2} fontSize="20px" color="brandPrimary.500" fontWeight="400">{t('common.teams') || "Teams"}</Heading>
          {isMobile && <IconButton icon={<Filters />} onClick={() => filterDisc.onToggle()} variant="transparent" />}
          {teamsSearchIsFetching ? <Spinner /> : ''}
        </HStack>
        <>
        {query?.query?.length && teamsTotalCount ? (
          <Text size="sm">{teamsTotalCount} {t('pageJobs.results') || "results"}</Text>
        ) : (
          ''
        )}
        </>
      </Stack>
      <SearchTeamsListing />
      
    </Stack>
  );
});
